// Render Prop

import React, { Component } from 'react';

import { Redirect } from 'react-router';
import { FormGroup, Label, Input } from 'reactstrap';
import TableWidget from "../../widgets/TableWidget";

import AccountStateButton from "../../widgets/AccountStateButton";


export class SelectAccount extends Component {
    static displayName = SelectAccount.name;

    constructor(props) {
        super(props);
        this.state = {
            selectedAccountId: false,
            selectedAccountStatusId: false,
            filterText : ""
        };

        this.props.store.updateBanner("Update Account");


        this.selectAccount = this.selectAccount.bind(this);
        this.selectAccountStatus = this.selectAccountStatus.bind(this);
        this.handleFilterChange = this.handleFilterChange.bind(this);
    }

    selectAccount(event) {
        const accountId = event.target.value;

        this.setState({ selectedAccountId: accountId })
    }

    selectAccountStatus(event) {
        const accountId = event.target.value;

        this.setState({ selectedAccountStatusId: accountId })
    }


    async handleFilterChange(event) {
        await this.setState({ filterText: event.target.value });
    }


    dataFilters() {
        return (
            <React.Fragment>
                <div className="col-12 col-md-6">
                    <Label for="studentFilter">Filter By Student Name or TUID</Label>
                    <Input placeHolder="Student Name / TUID..." type="text" id="studentFilter" value={this.state.filterText} onChange={this.handleFilterChange} />
                </div>
            </React.Fragment>
        )
    }


    render() {
        if (this.state.selectedAccountId) {
            return (<Redirect push to={"/staff/Account/" + this.state.selectedAccountId} />);
        }
        else if (this.state.selectedAccountStatusId) {
            return (<Redirect push to={"/staff/AccountStatus/" + this.state.selectedAccountStatusId} />);
        }
        //Default
        else {
            return (
                <div>
                    <div className="row">
                        {this.dataFilters()}
                    </div>
                    <div className="row">
                        {this.accountTable()}
                    </div>
                </div>
            )
        }
    }


    createHeadings() {
        //Creates the headings for the react-table


        const leftAlignCellProps = (state, rowInfo, column) => {
            return {
                style: {
                    textAlign: "right"
                }
            };
        }

        const columns =
            [
                {
                    Header: "", accessor: "col1",
                    Cell: (props) => (
                        <div>
                            <button className="btn btn-light" value={props.cell.value} onClick={this.selectAccount}>
                                Edit
                            </button>
                        </div>
                    ),
                    props: {
                        colspan: "1", style: { width: "10%", borderBottom: "3px solid white" }  
                    }
                },
                { Header: "Name", accessor: "col2", props: { colSpan: "1", style: { width: "20%" } } },
                { Header: "TUID", accessor: "col3", props: { colSpan: "1", style: { width: "10%" } } },
                { Header: "FOPAL", accessor: "col4", props: { colSpan: "1", style: { width: "10%" } } },
                {
                    Header: "Employer", accessor: "col5", props: { colSpan: "1", style: { width: "20%" } },
                },
                {
                    Header: "Account Status", accessor: "col6",
                    Cell: (props) => (
                        <div>
                            <AccountStateButton badge={true} accountId={props.cell.value} store={this.props.store} onClick={this.selectAccountStatus}/>
                        </div>
                    ),
                    props: {
                        colspan: "1", style: { colSpan: "1", style: { width: "10%" } }
                    }
                }
            ];

        return columns;
    }

    formatAccounts(accounts) {
        //format account data for the react-table

        const data = accounts.map((account) => {
            account.include(["student", "employer"])
            return {
                col1: account.id,
                col2: account.student.name,
                col3: account.student.tuid,
                col4: account.fopal,
                col5: account.employer.name,
                col6: account.id,
            }
        });

        return data;

    }

    accountTable() {
        let accounts = this.props.store.accounts.collection;

        //Sort accounts by the last name of the student.
        accounts.sort((a,b) => {
            a = a.include(["student"])
            b = b.include(["student"])

            if(a.student.lastName.toLowerCase() > b.student.lastName.toLowerCase()) {
                return 1;
            }
            else if(b.student.lastName.toLowerCase() > a.student.lastName.toLowerCase()) {
                return -1;
            }
            else {
                if(a.student.firstName.toLowerCase() > a.student.firstName.toLowerCase()) {
                    return 1;
                }
                else if(b.student.firstName.toLowerCase() > a.student.firstName.toLowerCase()) {
                    return -1;
                }
                return 0
            }
        });

        if (this.state.filterText) {
            /* Filter out any employers not matching the filter  */
            accounts = accounts.filter((account) => {
                return (
                    account.student.name.toLowerCase().includes(this.state.filterText.toLowerCase()) ||
                    account.student.tuid.includes(this.state.filterText)
                )
            });
        };



        const columns = this.createHeadings();
        const data = this.formatAccounts(accounts);


        return (
            <TableWidget
                tableProps={{ style: "mt-4" }}
                headerGroupProps={{}}
                rowProps={{}}
                columns={columns}
                data={data} />
        );
    }

 

}
